import type {
  FullScreen,
  ScreenWidthProp,
  ScreenHeightProp,
  FullWidthProp,
  FullHeightProp,
  SizingProps,
  HalfWidthProp,
} from 'src/types/sizing'

const sizingCustomProps = [
  'fullScreen',
  'fullWidth',
  'fullHeight',
  'screenWidth',
  'screenHeight',
  'noPadding',
  'noMargin',
  'width',
  'height',
  'halfWidth',
] as const

const isFullScreen = (props: SizingProps): props is FullScreen => 'fullScreen' in props && props.fullScreen === true
const isScreenWidth = (props: SizingProps): props is ScreenWidthProp => 'screenWidth' in props && props.screenWidth === true
const isScreenHeight = (props: SizingProps): props is ScreenHeightProp => 'screenHeight' in props && props.screenHeight === true
const isFullWidth = (props: SizingProps): props is FullWidthProp => 'fullWidth' in props && props.fullWidth === true

const isHalfWidth = (props: SizingProps): props is HalfWidthProp => 'halfWidth' in props && props.halfWidth === true
const isFullHeight = (props: SizingProps): props is FullHeightProp => 'fullHeight' in props && props.fullHeight === true

const isNoPadding = (props: SizingProps): boolean => 'noPadding' in props && props.noPadding === true
const isNoMargin = (props: SizingProps): boolean => 'noMargin' in props && props.noMargin === true

const getWidth = (props: SizingProps) => {
  if (isFullScreen(props) || isScreenWidth(props)) {
    return '100vw'
  }
  if (isFullWidth(props)) {
    return '100%'
  }
  if (isHalfWidth(props)) {
    return '50%'
  }
  return undefined
}

const getHeight = (props: SizingProps) => isFullScreen(props) || isScreenHeight(props)
  ? '100vh'
  : isFullHeight(props)
    ? '100%'
    : undefined
const sizingMixin = (props: SizingProps) => ({
  width: getWidth(props),
  height: getHeight(props),
  padding: isNoPadding(props)
    ? '0'
    : undefined,
  margin: isNoMargin(props)
    ? '0'
    : undefined,
})

export {
  isFullScreen,
  isScreenWidth,
  isScreenHeight,
  isFullWidth,
  isFullHeight,
  isNoPadding,
  isNoMargin,
  isHalfWidth,
  sizingMixin,
  sizingCustomProps,
}
